export enum EFeature {
  withNeighbors = 'withNeighbors',
}
